__turbopack_context__.v({
  "delayLong": "_4qNeUa_delayLong",
  "delayShort": "_4qNeUa_delayShort",
  "fade": "_4qNeUa_fade",
  "visible": "_4qNeUa_visible",
});
